import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiFormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableFooter from "@mui/material/TableFooter";
import TextField from "@mui/material/TextField";

import SearchIcon from "@mui/icons-material/Search";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";

import Modal from "../components/Modal";
import api from "../service/api";
import { setError, setSuccess } from "../reducers/appSlice";


const ModalButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const TablePaginationActions = (props) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const SeleccionarOrganismo = (props) => {
  const dispatch = useDispatch();
  const [datos, setDatos] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [filter, setFilter] = useState("");
  const [filteredDatos,setfilteredDatos]=useState([]);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setFilter("");
    setOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const columns = [
    {
      id: "organismoId",
      label: "Código",
      minWidth: 100,
      align: "right",
    },

    {
      id: "descripcion",
      label: "Organismo",
      minWidth: 300,
      align: "left",
    },
    {
      id: "acciones",
      label: "Acciones",
      minWidth: 100,
      align: "center",
    },
  ];

  const obtenerOrganismos = async () => {
    try {
      const response = await api.obtenerOrganismosGrupoActor();
  
      const filtrados = (response.data || []).filter(
        (item) => item.organismoId != null
      );
  
      setDatos(filtrados);
      setfilteredDatos(filtrados);
  
      return filtrados;
    } catch (error) {
      console.error("Error al obtener organismos:", error);
  
      const mensaje =
        error.response?.data?.error ||
        error.message ||
        "Error al obtener los organismos";
  
      dispatch(setError(mensaje));
  
      setDatos([]);
      setfilteredDatos([]);
  
      return [];
    }
  };

  const filterData = (element) => {
    const filtroTexto = (filter || "").toString().toLowerCase().trim();

    // Búsqueda exacta en organismoId
    if (element.organismoId?.toLowerCase() === filtroTexto) {
        return true;
    }

    // Búsqueda por frase completa en descripcion
    return element.descripcion?.toLowerCase().includes(filtroTexto);
};

useEffect(() => {
    obtenerOrganismos();
    setFilter("");
}, []);

useEffect(() => {
    const sortedData = [...datos].sort((a, b) => a.organismoId.localeCompare(b.organismoId));
    setfilteredDatos(sortedData); 
    setFilter("");  
}, [datos]);

useEffect(() => {
  const filtroTexto = (filter || "").toString().trim(); // Asegurar que filter sea string

  if (filtroTexto) {
      setfilteredDatos(datos.filter(filterData));
  } else {
      setfilteredDatos(datos);
  }
}, [filter, datos]);

  

  return (
    <div>
      {props.mostrar === "boton" ? (
        <ModalButton
          variant="plata"
          onClick={handleOpen}
          endIcon={<SearchIcon />}
        >
          Organismo
        </ModalButton>
      ) : (
        <IconButton color="primary" onClick={handleOpen}>
          <SearchIcon fontSize="small" />
        </IconButton>
      )}
      <Modal
        open={open}
        handleClose={handleClose}
        title="ORGANISMOS DE TU GRUPO"
        responsiveTitle="ORGANISMOS"
        closeButton
      >
        
        <Box sx={{ display: "flex", flexDirection: "row" }}>
                <TextField sx={{border:1,borderColor: "grey.300",borderRadius:1,mb:1,mt:1}} id="filtro" label="Buscar" variant="outlined" size="small" value={filter}  onChange={(event) => setFilter(event.target.value)} /> 
        </Box>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table size="small" sx={{ border: "1px solid #dee2e6" }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    sx={{
                      backgroundColor: "#fff",
                      color: "#3c4b64",
                      minWidth: column.minWidth,
                    }}
                    key={column.id}
                    align={column.align}
                  >
                    <b>{column.label}</b>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredDatos
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((dato, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={index}>
                      {columns.map((column) => {
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.id === "acciones" ? (
                              <IconButton
                                title="Seleccionar"
                                onClick={() => {
                                  props.resultado(dato);
                                  handleClose();
                                }}
                              >
                                <DoneOutlineRounded sx={{ fontSize: 14 }} />
                              </IconButton>
                            ) : (
                              dato[column.id]
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
                {submitting ? (
                  <TableRow>
                    <TableCell colSpan="7" align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                  null
                )}
                {filteredDatos.length === 0 && !submitting ? (
                  <TableRow>
                  <TableCell colSpan="7" align="center">
                    <Typography variant="aclaracion">No hay datos para mostrar</Typography>
                  </TableCell>
                </TableRow>
                ) : (
                  null
                )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[
                    5,
                    10,
                    25,
                    { label: "Todas", value: filteredDatos.length },
                  ]}
                  colSpan={columns.length}
                  count={filteredDatos.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "filas pr página",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Modal>
    </div>
  );
};

export default SeleccionarOrganismo;
